import includes from "lodash/includes";
import styled from "styled-components";
const SIZES = {
    ICON_WIDTH: 24
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes([
            "bgColor",
            "borderColor",
            "bgColorHover",
            "bgColorActive",
            "borderColorHover",
            "borderColorActive",
            "blockWidth",
            "blockHeight"
        ], prop)
    }) `
    display: grid;
    grid-template-columns: ${SIZES.ICON_WIDTH}px 1fr;
    align-items: center;
    ${({ blockWidth }) => blockWidth && `width: ${blockWidth}px;`}
    ${({ blockHeight }) => blockHeight && `height: ${blockHeight}px;`}

    border-radius: ${({ theme }) => theme["border-radius-base"]};
    background-color: ${({ theme, bgColor }) => theme[bgColor] || bgColor};
    border: 1px solid ${({ theme, borderColor }) => theme[borderColor] || borderColor};

    &:hover {
      background-color: ${({ theme, bgColorHover }) => theme[bgColorHover] || bgColorHover};
      border-color: ${({ theme, borderColorHover }) => theme[borderColorHover] || borderColorHover};
    }
    &:active {
      background-color: ${({ theme, bgColorActive }) => bgColorActive ? theme[bgColorActive] || bgColorActive : "transparent"};
      border-color: ${({ theme, borderColorActive }) => borderColorActive ? theme[borderColorActive] || borderColorActive : "transparent"};
    }
  `,
    Icon: styled.i.withConfig({
        shouldForwardProp: (prop) => !includes(["color"], prop)
    }) `
    color: ${({ theme, color }) => (color ? theme[color] || color : "unset")};
  `
};
